import { Component } from '@angular/core';
import { LigaSeasonWidgetComponent } from './components/ligaseasonwidget.component';
import { NewMemberWidgetComponent } from './components/newmemberwidget.component';
import { PanelModule } from 'primeng/panel';
import { ArchiveLeaguesWidget } from "./components/archiveleagueswidget.component";
import { GlobalNotificationWidget } from "./components/globalnotification.component";
import { MediaWidget } from "./components/mediawidget.component";
import { VotingAnnouncementWidget } from "./components/votingannouncement.component";
import { RegistrationAnnouncementWidget } from "./components/registrationannouncement.component";

@Component({
    selector: 'app-dashboard',
    imports: [
    LigaSeasonWidgetComponent,
    NewMemberWidgetComponent,
    PanelModule,
    ArchiveLeaguesWidget,
    GlobalNotificationWidget,
    MediaWidget,
    VotingAnnouncementWidget,
    RegistrationAnnouncementWidget
],
    template: `
        <div>
            <app-global-notification-widget />
        </div>
        <div class="mt-4">
            <app-voting-announcement-widget />
        </div>
        <div class="mt-4">
            <app-registration-announcement-widget />
        </div>
        <div class="mt-4">
            <app-liga-season-widget />
        </div>
        <div class="mt-8">
            <!-- Below the fold: don't let the archive requests compete with the
                 initial page load — start them when the widget scrolls into view. -->
            @defer (on viewport) {
                <app-archive-leagues-widget />
            } @placeholder {
                <div class="card" style="min-height: 12rem"></div>
            }
        </div>
        <div class="mt-8">
            <app-newmember-widget />
        </div>
        
        <div class="mt-8">
            <app-media-widget />
        </div>
        

    `
})
export class Dashboard {}
